import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-user-sync-handler',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-sync-handler.component.html',
  styleUrl: './user-sync-handler.component.css',
})
export class UserSyncHandlerComponent {
  constructor(public readonly auth: AuthService) {}

  // Placeholder for future sync logic
}

